import MainFrame from './mainFrame';


export default MainFrame;